<template lang="pug">
.content(:class="{ 'is-sortable': edit && sortable, 'is-deletable': deletable, 'is-restorable': content.deleted }")
    .title-bar(v-if="edit")
        h4(:class="{ handle: sortable }")
            template(v-if="sortable")
                //- span.el-icon-fa-sort.fas
                span.icon.sort
                    svg(xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6")
                        //- path(stroke-linecap="round" stroke-linejoin="round" d="M3 7.5L7.5 3m0 0L12 7.5M7.5 3v13.5m13.5 0L16.5 21m0 0L12 16.5m4.5 4.5V7.5" )
                        path(stroke-linecap="round" stroke-linejoin="round" d="M3.75 5.25h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5" )
            span {{ $t('Pin \#{nr}', { nr: index + 1 }) }}
        .grow
        el-button.restore-content(
            v-if="content.deleted"
            circle type="info" size="mini"
            icon="el-icon-fa-trash-restore fas"
            @click.prevent.stop="restoreContent(content.id)"
        )
        el-button.delete-content(
            v-else-if="deletable"
            circle type="danger" size="mini"
            icon="el-icon-fa-trash-alt far"
            @click.prevent.stop="deleteContent(content.id)"
        )
    .fields(
        v-for="fields in rows"
        v-if="fields.length"
        :class="{ edit, 'inline-fields': fields.length > 1, 'deleted': content.deleted }"
    )
        .field(
            v-for="field in fields" :key="field.key"
            v-if="checkConditions(field)"
            :class="[field.key, { edit, deleted: content.deleted }]"
        )
            component(
                :is="field.key === 'address' ? 'AddressField' : 'InputField'"
                :section="section"
                :content="content"
                :config="field"
                :settings="config.settings"
                :section-settings="sectionSettings"
                :section-setting-values="sectionSettingValues"
                :maxlength="field.maxlength || 255"
                :options="options"
                :edit="edit"
            )
</template>

<i18n>
{
    "en": {
        "Pin #{nr}": "Pin #{nr}",
        "Pin \\#{nr}": "Pin \\#{nr}"
    },
    "de": {
        "Pin #{nr}": "{nr}. Pin"
    }
}
</i18n>

<script>
import InputContent from '@/components/Page/Sections/Partials/InputContent'

export default {
    name: 'MarkerContent',
    extends: InputContent,
    computed: {
        rows() {
            const fields = this.config.fields || []

            let rows = []

            // 1. row
            rows[0] = []

            const addressField = fields.find(el => el.key === 'address')
            if (addressField) rows[0].push(addressField)
            else rows[0].push({ key: 'address', name: 'Adresse', type: 'compact' })

            const charField = fields.find(el => el.key === 'sub_title')
            if (charField) rows[0].push({ maxlength: 1, ...charField })

            const colorField = fields.find(el => el.key === 'color')
            if (colorField) rows[0].push(colorField)

            // 2. row
            rows[1] = []

            const titleField = fields.find(el => el.key === 'title')
            if (titleField) rows[1].push(titleField)

            // 3. row
            rows[2] = []

            const textField = fields.find(el => el.key === 'text')
            if (textField) rows[2].push(textField)

            // 4. row
            rows[3] = []

            const linkField = fields.find(el => el.key === 'hyperlink')
            if (linkField) rows[3].push(linkField)

            return rows

        },
        firstLineFields() {
            let inlineFields = []
            const fields = this.config.fields || []

            const titleField = fields.find(el => el.key === 'title')
            if (titleField) inlineFields.push(titleField)

            const charField = fields.find(el => el.key === 'sub_title')
            if (charField) inlineFields.push(charField)

            return inlineFields
        },
        secondLineFields() {
            let inlineFields = []
            const fields = this.config.fields || []

            const linkField = fields.find(el => el.key === 'hyperlink')
            if (linkField) inlineFields.push(linkField)

            const addressField = fields.find(el => el.key === 'address')
            if (addressField) inlineFields.push(addressField)
            else inlineFields.push({ key: 'address', name: 'Adresse', type: 'compact' })

            const colorField = fields.find(el => el.key === 'color')
            if (colorField) inlineFields.push(colorField)

            return inlineFields
        },
        otherFields() {
            const fields = this.config.fields || []
            return fields.filter(el => ['text'].includes(el.key))
        },
    }
}
</script>

<style lang="sass" scoped>
.field
    margin-bottom: 1rem
.inline-fields
    display: flex
    // gap: 1rem
    .field + .field
        margin-left: 1rem
    .field
        flex-grow: 1
        &.sub_title
            flex-grow: 0
            flex-basis: 80px
            ::v-deep input
                // text-align: center
                text-transform: uppercase
                font-weight: bold
        &.color
            flex-grow: 0
            width: 35px
        &.address
            &::v-deep
                .el-form-item
                    margin-bottom: 0
        &.color::v-deep .colorpicker
            display: flex
        &.hyperlink
            margin-bottom: .5rem
</style>
